module.exports = __webpack_public_path__ + "4ce6df19482ac97d922676e4fddccf2f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/CMF_logo.svg
// module id = 227
// module chunks = 0